<template>
  <div style="height: 50%;">
    <b-container fluid class="fullHeight">
      <b-row class="fullHeight">
        <b-col class="fullHeight" style="padding:0px;">
          <el-tabs
            type="border-card"
            tab-position="bottom"
            class="fullHeight"
            style="width:100%;height: 100%;"
          >
            <el-tab-pane v-for="(stickerPackage, index) in stickerPackages" :key="index">
              <span slot="label">
                <b-img :src="stickerPackage.Stickers[0].PreviewImageUrl" style="width:40px;"></b-img>
              </span>
              <b-container fluid>
                <b-row>
                  <b-col
                    cols="4"
                    sm="4"
                    md="3"
                    lg="2"
                    xl="1"
                    v-for="(Sticker, index2) in stickerPackage.Stickers"
                    @click="sendSticker(Sticker)"
                    style="text-align:center; padding:0px;"
                    :key="index2"
                  >
                    <b-img :src="Sticker.PreviewImageUrl" class="Sticker" fluid></b-img>
                  </b-col>
                </b-row>
              </b-container>
            </el-tab-pane>
            <el-tab-pane v-if="noStickerPackages()">
              <span slot="label"></span>
              <div style="text-align: center;">目前無可用貼圖</div>
            </el-tab-pane>
          </el-tabs>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { StickerHandler } from "@/handler/StickerHandler.js";
import store_sticker from "@/vuex/store_sticker.js";

export default {
  props: ["roomInfo", "staffInfo"],
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
    sendSticker: function(Sticker) {
      var sendReustl = StickerHandler.sendSticker(
        Sticker.StickerId,
        this.roomInfo.RoomId,
        this.staffInfo.StaffID
      );
      store_sticker.dispatch(
        "showStickerPackages",
        !store_sticker.state.stickerPackagesVisible
      );
    },
    noStickerPackages: function() {
      if (this.stickerPackages.length == 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  computed: {
    stickerPackages() {
      return store_sticker.state.stickerPackages;
    }
  }
};
</script>

<style>
.Sticker {
  width: auto;
  height: auto;
  max-height: 100px;
  cursor: pointer;
}
.el-tabs__content {
  overflow: auto !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/Sticker.vue